<template>
  <v-chart id="cost" v-if="ready"  :options="graph"/>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'


export default {
  name: 'cost',
  components: {'v-chart': ECharts},
  props: ['data'],
  data() {
    return {
      ready: false,
      graph :{
        xAxis: {
          type: 'category',
          data: this.data.xAxis,
          nameRotate: 90,
          axisLabel : {
            rotate: 90
          },
        },
        grid:{
          right: 0,
          left: 240,
          bottom: 200
        },
        legend: {
          left:20,
          top: 50,
          data:['Margen Bruto', 'Margen Neto', 'Rentabilidad','Rinde de Equilibrio', 'Precio de Equilibrio', 'Inversión', 'Costo de cultivo', 'Ciclo',],
          selectedMode: 'single',
          itemGap: 25,
          orient: 'vertical',
          textStyle: {
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 'dataMax',
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: function (value) {
              value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              return value;
            }
          },
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888'
        },
        series: [
          {
            name: 'Margen Bruto',
            data: this.data.margins[0],
            type: 'bar',
            stack:'one',
            color: '#249DA5',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (USD/ha)',
              color: '#fff',
              fontWeight: 'bold'
            },

          },
          {
            name: 'Margen Neto',
            data: this.data.margins[1],
            type: 'bar',
            stack:'one',
            color: '#0961AF',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (USD/ha)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Rentabilidad',
            data: this.data.margins[2],
            type: 'bar',
            stack:'one',
            color: '#2CAC74',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c} (%)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Rinde de Equilibrio',
            data: this.data.margins[3],
            type: 'bar',
            stack:'one',
            color: '#888',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (qq/ha)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Precio de Equilibrio',
            data: this.data.margins[4],
            type: 'bar',
            stack:'one',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (USD/t)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Inversión',
            data: this.data.margins[5],
            type: 'bar',
            stack:'one',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (USD/ha)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Costo de cultivo',
            data: this.data.margins[6],
            type: 'bar',
            stack:'one',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (USD/ha)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },
          {
            name: 'Ciclo',
            data: this.data.margins[7],
            type: 'bar',
            stack:'one',
            barMaxWidth: 120,
            label: {
              show: true,
              formatter: '{c}\n (Meses)',
              color: '#fff',
              fontWeight: 'bold'
            },
          },

        ]
      }
    }
  },
  methods: {
    sum (index) {
      return (parseInt(this.data.margins[0][index]) || 0) +
        (parseInt(this.data.margins[1][index]) || 0) +
        (parseInt(this.data.margins[2][index]) || 0) +
        (parseInt(this.data.margins[3][index]) || 0) +
        (parseInt(this.data.margins[4][index]) || 0) +
        (parseInt(this.data.margins[5][index]) || 0);
    },
    modifyChartInMobileView() {
      if (window.screen.width <= 960) {
        this.data.xAxis.splice(2);
        this.graph.grid.left = 300;
      }
      if (window.screen.width <= 600) {
        this.graph.grid.left = 130;
        this.graph.legend.left = 0;
        this.graph.legend.textStyle.fontSize = 9;
      }
    }

  },
  mounted(){
    this.modifyChartInMobileView();

    this.$nextTick(function() {
      this.ready = true
    })

  }
}
</script>
<style>

#cost{
    height: 550px
}
</style>
